import {readable} from 'svelte/store';

const cities = readable({}, function start(set) {
    set({
        'global': {
            'id': '',
            'name': '',
            'locative': '',
            'locativeIn': '',
            'locativeInUrl': '',
            'address': '',
            'postalCode': '',
            'phone': '',
            'email': '',
        },
        'torun': {
            'id': 'torun',
            'name': 'Toruń',
            'locative': 'Toruniu',
            'locativeIn': 'w Toruniu',
            'locativeInUrl': '-w-toruniu',
            'address': 'ul. Wschodnia 34',
            'postalCode': '87-100',
            'phone': '+48 504 64 64 66',
            'phoneCall': '504646466',
            'email': 'kontakt@colligo.pl',
            "latitude": "53.027435824872704",
            "longitude": "18.6444163839591"
        },
        'bydgoszcz': {
            'id': 'bydgoszcz',
            'name': 'Bydgoszcz',
            'locative': 'Bydgoszczy',
            'locativeIn': 'w Bydgoszczy',
            'locativeInUrl': '-w-bydgoszczy',
            'address': 'ul. Jana Zamoyskiego 2',
            'postalCode': '85-063',
            'phone': '+48 798 238 449',
            'phoneCall': '798238449',
            'email': 'bydgoszcz@colligo.pl',
            "latitude": "53.135028569170984",
            "longitude": "18.035714687657833"
        }
    });

    return function stop() {};
});

export default cities;